import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getMonth } from "date-fns";
import { stat_getStat1, stat_getStat2, stat_recalcStat1 } from "src/data/stat/statFunctions";
import { useUserData } from "./userContext";

const StatContext = createContext();

export const StatProvider = ({ children }) => {
  const { userAsiakas, token } = useUserData();
  const [selectedMonth, setSelectedMonth] = useState();
  const [selectedYear, setSelectedYear] = useState();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [selectedMonthData, setSelectedMonthData] = useState([]);
  const [selectedMonthData2, setSelectedMonthData2] = useState([]);
  const [comparingMonthData, setComparingMonthData] = useState([]);
  const [comparingMonthsCount, setComparingMonthsCount] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!userAsiakas) return;
    const asynk = async () => {
      setSelectedMonth(getMonth(new Date()) + 1);
      setSelectedYear(new Date().getFullYear());
      const data = await getData();
      setData(data);
      setSelectedMonthData(
        data.filter((item) => item.year === selectedYear && item.month === selectedMonth)
      );
      const data2 = await getData2();
      setData2(data2);
      setSelectedMonthData2(
        data2.filter((item) => item.year === selectedYear && item.month === selectedMonth)
      );
    };
    asynk().then(() => {
      setIsLoading(false);
      setIsLoaded(true);
    });
  }, [userAsiakas]);

  useEffect(() => {
    if (!isLoaded) return;
    setSelectedMonthData(
      data.filter((item) => item.year === selectedYear && item.month === selectedMonth)
    );
    setSelectedMonthData2(
      data2.filter((item) => item.year === selectedYear && item.month === selectedMonth)
    );
  }, [isLoaded, selectedMonth, selectedYear]);

  useEffect(() => {
    if (!isLoaded) return;
    // set comparingMonthData using all months from 1 to 3 months ago
    // if selectedMonth is 1, then comparingMonthData will be from 10, 11, 12
    // if selectedMonth is 2, then comparingMonthData will be from 11, 12, 1
    // if selectedMonth is 3, then comparingMonthData will be from 12, 1, 2
    // if selectedMonth is 4, then comparingMonthData will be from 1, 2, 3
    // if selectedMonth is 5, then comparingMonthData will be from 2, 3, 4
    const comparingMonthDataRows = [];
    for (let i = 1; i <= comparingMonthsCount; i++) {
      let month = selectedMonth - i;
      let year = selectedYear;
      if (month <= 0) {
        month = 12 + month;
        year = year - 1;
      }
      comparingMonthDataRows.push(
        data.filter((item) => item.year === year && item.month === month)
      );
    }
    // flatten the array by removing statId, year and month, and calculate sum the values attachmentCount, attachmentSize, googleMapsCount, keikkaCount, keikkaMinutes, m3 and palkkiCount

    const comparingMonthData = {
      attachmentCount: 0,
      attachmentSize: 0,
      googleMapsCount: 0,
      keikkaCount: 0,
      keikkaMinutes: 0,
      m3: 0,
      palkkiCount: 0,
      asiakasCount: 0,
      tyomaaCount: 0,
    };

    for (let i = 0; i < comparingMonthDataRows.length; i++) {
      const item = comparingMonthDataRows[i][0];
      if (!item) continue;
      comparingMonthData.attachmentCount += item.attachmentCount;
      comparingMonthData.attachmentSize += item.attachmentSize;
      comparingMonthData.googleMapsCount += item.googleMapsCount;
      comparingMonthData.keikkaCount += item.keikkaCount;
      comparingMonthData.keikkaMinutes += item.keikkaMinutes;
      comparingMonthData.m3 += item.m3;
      comparingMonthData.palkkiCount += item.palkkiCount;
      comparingMonthData.asiakasCount += item.asiakasCount;
      comparingMonthData.tyomaaCount += item.tyomaaCount;
    }
    setComparingMonthData(comparingMonthData);
  }, [isLoaded, selectedMonthData, comparingMonthsCount]);

  const getData = async () => {
    return await stat_getStat1(null, null, userAsiakas.asiakasId, token);
  };
  const getData2 = async () => {
    const pumppuAsiakasId = userAsiakas.isPumppuToimittaja ? userAsiakas.asiakasId : null;
    const betoniAsiakasId = userAsiakas.isBetoniToimittaja ? userAsiakas.asiakasId : null;
    return await stat_getStat2(pumppuAsiakasId, betoniAsiakasId, token);
  };

  const recalcStat = async (year, month) => {
    setData([]);
    setIsLoading(true);
    await stat_recalcStat1(year, month, userAsiakas.asiakasId, token);
    const data = await getData();
    setData(data);
    const data2 = await getData2();
    setData2(data2);
    setIsLoading(false);
  };

  return (
    <StatContext.Provider
      value={{
        selectedMonth,
        setSelectedMonth,
        selectedYear,
        setSelectedYear,
        data,
        data2,
        selectedMonthData,
        selectedMonthData2,
        comparingMonthData,
        comparingMonthsCount,
        setComparingMonthsCount,
        recalcStat,
        isLoading,
        isLoaded,
      }}>
      {children}
    </StatContext.Provider>
  );
};

export const useStatData = () => useContext(StatContext);

StatProvider.propTypes = {
  children: PropTypes.node,
};
